import { render } from "./skeleton-loader.vue?vue&type=template&id=1dd7b044&scoped=true"
import script from "./skeleton-loader.vue?vue&type=script&setup=true&lang=js"
export * from "./skeleton-loader.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./skeleton-loader.vue?vue&type=style&index=0&id=1dd7b044&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./skeleton-loader.vue?vue&type=style&index=0&id=1dd7b044&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("1dd7b044")
  })
}
import "./skeleton-loader.vue?vue&type=style&index=1&id=1dd7b044&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-1dd7b044"],['__file',"resources/js/common/shared/components/skeleton-loader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dd7b044"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dd7b044', __exports__)) {
    api.reload('1dd7b044', __exports__)
  }
  
  module.hot.accept("./skeleton-loader.vue?vue&type=template&id=1dd7b044&scoped=true", () => {
    api.rerender('1dd7b044', render)
  })

}


export default __exports__